// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__11FAS","error":"Textarea_error___Zv9P","readonly":"Textarea_readonly__27LZ7","disabled":"Textarea_disabled__1Znti"};